export default {
  props: {
    valid: { type: Boolean, required: true },
  },

  render() {
    return (
      <button
        class={`inline-flex items-center space-x-2 rounded-md px-5 py-2 text-sm font-medium uppercase tracking-wide text-white transition duration-150 ease-in-out focus:outline-none ${
          this.valid
            ? 'bg-colescba-blue-500 hover:bg-colescba-blue-600 focus:ring-1 focus:ring-colescba-blue-500 focus:ring-offset-1'
            : 'cursor-not-allowed bg-gray-400'
        }`}
        type="button"
        disabled={!this.valid}
      >
        {this.$slots.default || 'Siguiente'}
      </button>
    )
  },
}
